/*
 * Copyright 2025 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign, __rest } from "tslib";
import classNames from "classnames";
import * as React from "react";
import { Classes } from "../../common";
import { DISPLAYNAME_PREFIX } from "../../common/props";
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
export var NavbarDivider = function (_a) {
    var className = _a.className, htmlProps = __rest(_a, ["className"]);
    return React.createElement("div", __assign({ className: classNames(Classes.NAVBAR_DIVIDER, className) }, htmlProps));
};
NavbarDivider.displayName = "".concat(DISPLAYNAME_PREFIX, ".NavbarDivider");
//# sourceMappingURL=navbarDivider.js.map